import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {DEFAULT_NOTIFICATION_CONFIRM_BUTTON_LABEL, NotificationDialogDefinition} from '@aviary/dialogs/notification-dialog/notification-dialog.types';
import {BaseDialogDefinition} from '@aviary/dialogs/base-dialog/base-dialog.types';
import {MatDialogRef} from '@angular/material/dialog';
import {BaseDialogComponent} from '@aviary/dialogs/base-dialog/base-dialog.component';

@Component({
  selector: 'mx-notification-dialog',
  host: {
    class: 'hk-delegate-vertical-scrolling grow'
  },
  template: `
    <mx-base-dialog
      [definition]="baseDialogDefinition"
      [showCancelButton]="false"
      [showConfirmButton]="showConfirmButton"
      [showAdditionalActionButtons]="showAdditionalActionButtons">
      <ng-content/>

      <ng-container additionalActionButtons>
        <ng-content select="[additionalActionButtons]"/>
      </ng-container>
    </mx-base-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseDialogComponent]
})
export class NotificationDialogComponent {

  @Input()
  public set definition(definition: NotificationDialogDefinition) {
    this.baseDialogDefinition = {
      confirmButtonLabel: DEFAULT_NOTIFICATION_CONFIRM_BUTTON_LABEL,
      valueCalculator: () => undefined,
      ...definition
    };
  }

  @Input() public showConfirmButton: boolean = true;
  @Input() public showAdditionalActionButtons: boolean = false;

  public baseDialogDefinition: BaseDialogDefinition<void>;

  private readonly dialog: MatDialogRef<NotificationDialogComponent, void> = inject(MatDialogRef);

  public onDialogConfirm(): void {
    this.dialog.close();
  }
}
